<template>
  <div class="transition">
    <BasicText size="h5">{{props.in.typeDemande === 'SpecifiqueTT' ? 'Type de badge/carte ?' : 'Quel sous-dispositif ?'}}</BasicText>
    <div class="transition-items">
      <BasicCheckbox
        v-for="item in sousDispositifsItems"
        :key="item.code"
        :label="item.intitule"
        :model-value="estRadionOn(item.code)"
        @update:model-value="updateOut(item.code)"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
  import type { HabilitationDispositifDTO } from '@/features/api/extranet/dto/Demande/shared'
  import { SousDispositifLibelle as SousDispositifAFLib } from '@/features/domaine/types/opco/Demande/AF'
  import { SousDispositifLibelle as SousDispositifCPROLib } from '@/features/domaine/types/opco/Demande/CPRO'
  import { SousDispositifLibelle as SousDispositifCXPILib } from '@/features/domaine/types/opco/Demande/CXPI'
  import { SousDispositifLibelle as SousDispositifOUTILFPELib } from '@/features/domaine/types/opco/Demande/OUTILFPE'
  import { SousDispositifLibelle as SousDispositifPROALib } from '@/features/domaine/types/opco/Demande/PROA'
  import type { CarteEvents, CarteProps } from '@/features/interface/machine-etats/types'
  import { computed } from 'vue'

  const props = defineProps<CarteProps<HabilitationDispositifDTO, string>>()
  const emits = defineEmits<CarteEvents<string>>()

  const sousDispositifsItems = computed(() => {
    const makeItems = <T extends string>(keys: string[], libelles: Record<T, string>) =>
      keys.map((key) => ({
        code: key,
        intitule: libelles[key as T],
      }))

    switch (props.in.code) {
      case 'AF': {
        const items = makeItems(props.in.sousDispositifs, SousDispositifAFLib)
        return items.sort((a, b) => (a.code === 'PDC' ? -1 : b.code === 'PDC' ? 1 : 0))
      }
      case 'CPRO':
        return makeItems(props.in.sousDispositifs, SousDispositifCPROLib)
      case 'PROA':
        return makeItems(props.in.sousDispositifs, SousDispositifPROALib)
      case 'FPE':
        return makeItems(props.in.sousDispositifs, {
          ...SousDispositifCXPILib,
          ...SousDispositifOUTILFPELib
        })
      default:
        return []
    }
  })

  const estRadionOn = (item: string) => {
    return props.out === item
  }

  const updateOut = (item: string) => {
    emits('outChanged', true, item)
  }
</script>
<style lang="less" scoped>
  @import './ChoixCarte.less';
</style>

